// Static parenting content data (French)

export { ADVICE, STAGES } from "./advice";

export { ACTIVITIES } from "./activities";

export { QUIZZES, QUIZ_CATEGORIES } from "./quizzes";

export { CHALLENGE_TEMPLATES, CHALLENGE_CATEGORIES } from "./challenges";
export const MOODS = [
  { key: "joyeux", label: "😊 Joyeux", color: "#FFF4DC" },
  { key: "calme", label: "😌 Calme", color: "#E6F5EF" },
  { key: "fatigue", label: "😴 Fatigué", color: "#E3EAF7" },
  { key: "colere", label: "😤 En colère", color: "#FBE2E9" },
  { key: "triste", label: "😢 Triste", color: "#D2EDE1" },
  { key: "excite", label: "🤩 Excité", color: "#FFF4DC" },
];

export const AGE_GROUPS = ["0-2", "3-5", "6-9", "10-12", "13+"];

export const COACH_PROMPTS = [
  "Gérer la colère au supermarché",
  "Rituel du coucher apaisant",
  "Mon enfant refuse d'aller à l'école",
  "Fratrie qui se dispute sans cesse",
  "Comment parler des émotions ?",
  "Réduire le temps d'écran sans conflit",
];
